import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "./axiosBaseQuery";
import { baseUrl} from "../../config/apiConfig";


/**
 * It creates an api with the base url and the endpoints
 * 
 * @returns apis
 */
export const api = createApi({
  reducerPath: "api",
  baseQuery: axiosBaseQuery({
    baseUrl,
  }
  ),
  endpoints: (builder) => ({
  }),
});


export const { endpoints } = api;
